module.exports = __webpack_public_path__ + "img/Frame-63.637b641f.svg";